/* Wheelyshop – mätning av 3D-visaren och livechatten (fas 2, 27 okt 2026, Ehsans beslut 11:50).
   Skickar egna kundhändelser med Shopify.analytics.publish. Pixeln "Wheelyshop jämförelse GA4" (350552390)
   tar emot dem och skickar till GA4 272446394 – bara när besökaren godkänt statistik (pixelns behörighet).
   Inga personuppgifter, inga order-id:n. Aldrig en Ads-konvertering eller GA4-nyckelhändelse.
   - 3D: en gemensam lyssnare för alla wf-*-3d-visare och DYU C6. Visarfilerna ändras inte.
     Aktiv användning = rotation/zoom med camera-change source "user-interaction", färgval, närbild (vyknapp/vyval), rundtur startad.
     Automatisk kamerarörelse (rundtur, vyövergång) räknas inte.
   - Livechatt: klick på Shopifys "Fråga vad du vill" (shopify-chat, öppet shadow root) när chatten öppnas.
   Konfiguration (pilotprodukter, produkt) kommer från snippets/wf-feature-measure.liquid. */
(function () {
  'use strict';
  var cfg = window.WF_FEATURE_MEASURE || {};
  if (!cfg.productId) { try { cfg.productId = String(window.ShopifyAnalytics.meta.product.id || ''); } catch (e) {} }
  if (window.__wfFeatureMeasure) return;
  window.__wfFeatureMeasure = true;
  if (window.Shopify && window.Shopify.designMode) return; // aldrig i temaredigeraren

  var themeRole = (window.Shopify && window.Shopify.theme && window.Shopify.theme.role) || '';
  var ss = {
    get: function (k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }
  };

  /* Alla wf_*-händelser från temat (även jämförelsens) får temats roll, så att pixeln kan sortera bort förhandsvisningar
     även när preview_theme_id inte längre står i adressen. */
  try {
    var orig = window.Shopify && Shopify.analytics && Shopify.analytics.publish;
    if (typeof orig === 'function' && !orig.__wfRole) {
      var wrapped = function (name, data) {
        if (/^wf_/.test(String(name)) && data && typeof data === 'object' && !data.theme_role) data.theme_role = themeRole;
        return orig.apply(this, arguments);
      };
      wrapped.__wfRole = true;
      Shopify.analytics.publish = wrapped;
    }
  } catch (e) {}

  function publish(name, data) {
    try {
      if (!(window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function')) return;
      var d = { theme_role: themeRole, page_type: cfg.pageType || '' };
      for (var k in data) if (data[k] !== undefined && data[k] !== null && data[k] !== '') d[k] = data[k];
      Shopify.analytics.publish(name, d);
      if (/[?&]wf_measure_debug=1(?:&|$)/.test(location.search) && window.console) console.info('[wf-measure]', name, d);
    } catch (e) {}
  }

  /* ---------- Livechatt ---------- */
  document.addEventListener('click', function (e) {
    var path = e.composedPath ? e.composedPath() : [];
    var inChat = false, btn = null;
    for (var i = 0; i < path.length; i++) {
      var n = path[i];
      if (!n || !n.tagName) continue;
      if (n.tagName === 'SHOPIFY-CHAT') inChat = true;
      if (!btn && n.tagName === 'BUTTON' && /(^|\s)activator(\s|$)/.test(n.getAttribute('part') || '')) btn = n;
    }
    if (!inChat || !btn) return;
    if (btn.getAttribute('aria-expanded') === 'true') return; // klicket stänger chatten
    var first = !ss.get('wf_chat_open');
    ss.set('wf_chat_open', '1');
    publish('wf_chat_open', { product_id: cfg.productId || '', first_in_session: first ? 1 : 0 });
  }, true);

  /* ---------- 3D ---------- */
  var pid = String(cfg.productId || '');
  var pilot = (cfg.pilot || []).map(String);
  if (!pid || (pilot.length && pilot.indexOf(pid) < 0)) return;
  var handle = cfg.productHandle || '';
  var base = function (extra) { var d = { product_id: pid, product_handle: handle }; for (var k in extra) d[k] = extra[k]; return d; };

  function isOpenButton(el) {
    if (!el || !el.matches) return false;
    if (el.matches('.wf-c6-model-button')) return true;
    if (!el.matches('button[data-open][aria-haspopup="dialog"]')) return false;
    var host = el.parentElement;
    while (host && !/^WF-.+-3D$/.test(host.tagName)) host = host.parentElement;
    return !!host;
  }

  /* Knappen syns: minst 50 % inom bild i minst 1 s. En gång per session och produkt. */
  var seenKey = 'wf3d_vis:' + pid;
  if ('IntersectionObserver' in window) {
    var timers = new WeakMap();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting && en.intersectionRatio >= 0.5) {
          if (!timers.get(en.target)) timers.set(en.target, setTimeout(function () {
            if (ss.get(seenKey)) return;
            ss.set(seenKey, '1');
            publish('wf_3d_button_visible', base({}));
            io.disconnect();
          }, 1000));
        } else {
          clearTimeout(timers.get(en.target)); timers.delete(en.target);
        }
      });
    }, { threshold: [0, 0.5, 1] });
    var watched = new WeakSet();
    var scan = function () {
      if (ss.get(seenKey)) return;
      document.querySelectorAll('button[data-open][aria-haspopup="dialog"], .wf-c6-model-button').forEach(function (b) {
        if (!watched.has(b) && isOpenButton(b)) { watched.add(b); io.observe(b); }
      });
    };
    scan();
    document.addEventListener('DOMContentLoaded', scan);
    window.addEventListener('load', scan);
    setTimeout(scan, 3000);
  }

  /* En öppning i taget. */
  var ctx = null;
  var lastInput = '';
  function interact(action) {
    if (!ctx || ctx.done[action]) return;
    ctx.done[action] = true;
    try { sessionStorage.setItem('wf3d_used:' + pid, '1'); } catch (e) {}
    publish('wf_3d_interact', base({ f3d_action: action }));
  }
  function finish(reason) {
    if (!ctx) return;
    var c = ctx; ctx = null;
    clearTimeout(c.timeout);
    if (c.mo) c.mo.disconnect();
    publish('wf_3d_close', base({ f3d_open_ms: Math.min(Date.now() - c.t0, 1800000), f3d_loaded: c.loaded ? 1 : 0, f3d_close: reason }));
  }
  var viewers = new WeakSet();
  function attachViewer(mv) {
    if (viewers.has(mv)) return;
    viewers.add(mv);
    mv.addEventListener('load', function () {
      if (!ctx || ctx.loaded) return;
      ctx.loaded = true;
      clearTimeout(ctx.timeout);
      publish('wf_3d_loaded', base({ f3d_load_ms: Date.now() - ctx.t0 }));
    });
    mv.addEventListener('error', function (e) {
      if (!ctx || ctx.errored) return;
      ctx.errored = true;
      var t = (e && e.detail && e.detail.type) || 'load';
      publish('wf_3d_error', base({ f3d_error: String(t).slice(0, 40) }));
    });
    mv.addEventListener('camera-change', function (e) {
      if (!e.detail || e.detail.source !== 'user-interaction') return;
      interact(lastInput === 'zoom' ? 'zoom' : 'rotate');
    });
    mv.addEventListener('wheel', function () { lastInput = 'zoom'; }, { passive: true });
    mv.addEventListener('pointerdown', function () { lastInput = 'rotate'; }, { passive: true });
    mv.addEventListener('touchstart', function (e) { lastInput = e.touches && e.touches.length > 1 ? 'zoom' : 'rotate'; }, { passive: true });
    mv.addEventListener('touchmove', function (e) { if (e.touches && e.touches.length > 1) lastInput = 'zoom'; }, { passive: true });
  }
  function findViewers(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.tagName === 'MODEL-VIEWER') attachViewer(root);
    root.querySelectorAll('model-viewer').forEach(attachViewer);
  }

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('button') : null;
    if (!t) return;
    if (isOpenButton(t)) {
      if (ctx) finish('reopen');
      var target = document.getElementById(t.getAttribute('aria-controls') || '');
      var firstKey = 'wf3d_open:' + pid;
      var first = !ss.get(firstKey);
      ss.set(firstKey, '1');
      ctx = { t0: Date.now(), loaded: false, errored: false, done: {}, el: target };
      publish('wf_3d_open', base({ first_in_session: first ? 1 : 0 }));
      var c = ctx;
      c.timeout = setTimeout(function () {
        if (ctx === c && !c.loaded && !c.errored) { c.errored = true; publish('wf_3d_error', base({ f3d_error: 'timeout' })); }
      }, 30000);
      if (target) {
        findViewers(target);
        c.mo = new MutationObserver(function (ms) {
          ms.forEach(function (m) {
            if (m.type === 'attributes' && m.attributeName === 'open' && !target.hasAttribute('open') && ctx === c) finish('closed');
            m.addedNodes && m.addedNodes.forEach(function (n) { if (n.nodeType === 1) findViewers(n); });
          });
        });
        c.mo.observe(target, { attributes: true, attributeFilter: ['open'], childList: true, subtree: true });
      }
      // DYU C6 öppnar Shopifys produktmodal; model-viewer kan läggas in var som helst.
      setTimeout(function () { findViewers(document.body); }, 1500);
      return;
    }
    if (!ctx) return;
    var inside = ctx.el ? ctx.el.contains(t) : true;
    if (!inside) return;
    if (t.matches('[data-colour]') || t.closest('.wf-c6-colors')) return interact('color');
    if (t.matches('[data-tour]')) { if (t.getAttribute('aria-pressed') !== 'true') interact('tour_start'); return; }
    if (t.matches('[data-view]')) { if (t.getAttribute('data-view') !== 'all') interact('closeup'); return; }
    var act = t.getAttribute('data-camera-action');
    if (act === 'in' || act === 'out') interact('zoom');
  }, true);
  document.addEventListener('change', function (e) {
    if (!ctx) return;
    var t = e.target;
    if (ctx.el && !ctx.el.contains(t)) return;
    if (t.matches && t.matches('select[data-mobile-view]')) { if (t.value !== 'all') interact('closeup'); return; }
    if (t.matches && t.matches('input[type="radio"]')) interact('color');
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && ctx) setTimeout(function () { if (ctx && ctx.el && !ctx.el.hasAttribute('open')) finish('escape'); }, 50); }, true);
  window.addEventListener('pagehide', function () { if (ctx) finish('pagehide'); });
})();
